// A helper for persisting data in and reading data from local storage.
const storage = window.localStorage;

// we keep using this, so make it a default const
const KEY_DEFAULT = 'salesContact';

// Getter.
export const getState = (key) => {
  const data = storage.getItem(key || KEY_DEFAULT);
  // I wish there was an inverted nullish coalescent operator in JS.
  return data ? JSON.parse(data) : data;
};

// Setter.
export const setState = (key, value) => {
  storage.setItem(key || KEY_DEFAULT, JSON.stringify(value));
};

// Remover.
export const removeState = (key) => {
  storage.removeItem(key || KEY_DEFAULT);
};
